// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c368b345","297":"e848971c","306":"fccfa5dc","598":"e822d967","629":"21744663","813":"2ceb58fb","939":"5eba16ce","979":"93f472a7"}[chunkId] + ".chunk.js";
};